import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { Button } from 'UIPackage/MainModule/components/Button';
import { Checkbox } from 'UIPackage/MainModule/components/Checkbox';
import { IKnmDistrictSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';

import styles from './KnmObjectAddressModal.module.scss';

export interface ISelectObject {
  region?: IKnmDistrictSelectOption;
  regionName?: string;
  manualAddress?: string;
  address?: string;
  fiasRegion?: IKnmDistrictSelectOption;
}

/**
 * Функция вычисления label местоположения объекта кнм
 */
export const labelLocationObject = (object: ISelectObject) => {
  if (object.manualAddress) {
    return object.manualAddress;
  }

  return object.address;
};

interface IKnmObjectAddressModalProps {
  disabled?: boolean;
  isError: boolean;
  // Идентификатор поля ручного адреса, по нему форма скроллит к блоку
  manualAddressFieldId: string;
  objectsOfControl: ISelectObject[] | undefined;
  visible: boolean;
  isSelected: (object: ISelectObject) => boolean;
  onAccept: () => void;
  onCancel: () => void;
  onClose: () => void;
  onSelect: (object: ISelectObject) => void;
}

/**
 * Окно выбора адреса объекта контроля при установке галочки
 * "Адрес совпадает с адресом объекта"
 */
export const KnmObjectAddressModal = ({
  disabled,
  isError,
  manualAddressFieldId,
  objectsOfControl,
  visible,
  isSelected,
  onAccept,
  onCancel,
  onClose,
  onSelect,
}: IKnmObjectAddressModalProps) => {
  return (
    <Modal visible={visible} onClose={onClose} modalBodyClassName={styles.Modal}>
      <ModalHeader title="Добавление места проведения КНМ" />
      <ModalBody size="content">
        <span className={`${styles.AdviceSelectAddress} ${isError && styles.AdviceSelectAddressError}`}>
          Выберите адрес объект контроля
        </span>
        <div className={styles.SelectAddressFromObjectListWrapper} id={manualAddressFieldId}>
          <div className={styles.SelectAddressFromObjectListHeader}>АДРЕСА ОБЪЕКТОВ КОНТРОЛЯ</div>
          {!objectsOfControl || objectsOfControl.length === 0 ? (
            <span className={styles.AdviceSelectAddress}>Отсутствуют объекты контроля</span>
          ) : (
            <div className={styles.SelectAddressFromObjectListBody}>
              {objectsOfControl.map((object, i) => {
                return (
                  <div key={i} className={styles.AddressRow}>
                    <Checkbox
                      id={`objectControl.${i}`}
                      label={labelLocationObject(object)}
                      type="radio"
                      theme="system"
                      checked={isSelected(object)}
                      disabled={disabled}
                      onChange={() => onSelect(object)}
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </ModalBody>
      <ModalActions>
        <Button type="button" color="primary" size="medium" text="Выбрать" onClick={onAccept} />
        <Button color="default" text="Отменить" size="medium" type="button" onClick={onCancel} />
      </ModalActions>
    </Modal>
  );
};
